import { memo, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { Typography } from '@mui/material'

import InnerTab from './Tab'
import Table from './Table'
import Card from './Card'
import FilterPopover from '../../dataGrid/FilterPopover'

import styles from './index.module.scss'
import ButtonCustom from '../../atoms/button/ButtonCustom'

const VendorPayments = ({ data = [], openCreateModal }) => {
	const isSidebarOpen = useSelector((state) => state.sidebar.isSidebarOpen)

	const [innerTab, setInnerTab] = useState(0)
	const [search, setSearch] = useState('')
	const [filterAnchor, setFilterAnchor] = useState(null)
	const [statusFilter, setStatusFilter] = useState([])

	const filteredRows = useMemo(() => {
		const q = search.trim().toLowerCase()
		return data.filter((r) => {
			if (q && !r.party.toLowerCase().includes(q)) return false
			if (statusFilter.length && !statusFilter.includes(r.status))
				return false
			return true
		})
	}, [search, statusFilter, data])

	const openFilter = (e) => setFilterAnchor(e.currentTarget)
	const closeFilter = () => setFilterAnchor(null)
	const clearFilters = () => {
		setStatusFilter([])
	}

	const handleChangeInnerTab = (event, newValue) => {
		setInnerTab(newValue)
	}

	return (
		<>
			<div className={styles.pageHeader}>
				<Typography component="h1">Payments</Typography>
				<div className={styles.right}>
					<ButtonCustom
						variant="default"
						size="lg"
						onClick={openCreateModal}
						data-cy="create-invoice"
					>
						+ Create Invoice
					</ButtonCustom>
				</div>
			</div>

			<div className={styles.pageMain}>
				<InnerTab
					dataGrid={
						<div
							className={`${styles.pageScreen} ${isSidebarOpen ? styles.sidebarExpand : ''}`}
						>
							{filteredRows.map((item, index) => (
								<Card
									id={item.id}
									statusLabel={item.status}
									key={index}
									image={item.image}
									title={item.party}
									date={item.due_date}
									invoice={item.invoice}
									payment_id={item.payment_id}
									onViewDetail={item.viewDetails}
								/>
							))}
						</div>
					}
					dataList={
						<div>
							<Table rows={filteredRows} />
						</div>
					}
					innerTab={innerTab}
					handleChangeListCalendar={handleChangeInnerTab}
					onClickFilter={openFilter}
					searchQuery={search}
					onSearchChange={setSearch}
				/>
				<FilterPopover
					anchorEl={filterAnchor}
					open={Boolean(filterAnchor)}
					onClose={closeFilter}
					onClear={clearFilters}
					onApply={closeFilter}
					sections={[
						{
							id: 'status',
							title: 'Status',
							options: ['Completed', 'Charged', 'Pending'],
							selected: statusFilter,
							onToggle: (val, checked) =>
								setStatusFilter((prev) =>
									checked
										? [...prev, val]
										: prev.filter((x) => x !== val)
								),
						},
					]}
				/>
			</div>
		</>
	)
}

export default memo(VendorPayments)
